import { SmlJsonQueryFilter } from "@src/types/intelligence-search";

export function extractDimsAndMeasures(filters: SmlJsonQueryFilter[]) {
    const dimensions: string[] = [];
    const measures: string[] = [];

    filters
        ?.filter((f) => !f.operator)
        ?.forEach((filter) => {
            if (filter.meta) {
                const { asset_type, name } = filter.meta;

                if (asset_type === "dimension") {
                    dimensions.push(name);
                } else if (asset_type === "metric") {
                    measures.push(name);
                }
            }
        });

    return { dimensions, measures };
}
